"use client";

import { createContext, useContext, useState } from "react";
import { Reveal } from "../reveal";
import { HeroSectionType } from "../features/hero";
import { components } from "../shipping-calculator/hero";
import { PortableText } from "next-sanity";
import { cn } from "@/lib/utils";

interface HeroProps {
  data: HeroSectionType;
  children: Readonly<React.ReactNode>;
}

export const TrackerContext = createContext<{
  showExpandedHistory: boolean;
  setShowExpandedHistory: (val: boolean) => void;
  showDetails: boolean;
  setShowDetails: (val: boolean) => void;
}>({
  showExpandedHistory: false,
  setShowExpandedHistory: () => {},
  showDetails: false,
  setShowDetails: () => {},
});

export function Hero({ data, children }: HeroProps) {
  const { title, subtitle, description } = data;
  const [showExpandedHistory, setShowExpandedHistory] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  return (
    <TrackerContext.Provider value={{ showExpandedHistory, setShowExpandedHistory, showDetails, setShowDetails }}>
      <section className="-top-[130px] -mb-[130px] bg-primary-900 w-full overflow-hidden relative before:content-[''] before:absolute before:left-0 before:top-0 before:w-1/2 before:h-full before:bg-[url('/index/hero/right.svg')] before:bg-no-repeat before:bg-cover before:transform before:-scale-x-100 after:content-[''] after:absolute after:right-0 after:top-0 after:w-1/2 after:h-full after:bg-[url('/index/hero/right.svg')] after:bg-no-repeat after:bg-cover">
        <div className="max-w-screen-2xl mx-auto overflow-hidden z-[2] relative before:absolute before:content-[''] before:w-full before:h-full before:bg-[url('/index/hero/center.svg')] before:bg-cover before:bg-center before:bg-no-repeat py-[130px] sm:py-[140px] lg:py-[180px] before:top-0">
          <Reveal>
            <div className="relative flex flex-col items-center justify-center text-primary-text-50 max-w-screen-lg w-full mx-auto gap-16 px-6">
              <div className="flex w-full gap-6 flex-col items-center justify-center">
                <PortableText value={title} components={components} />
                {subtitle && (
                  <PortableText value={subtitle} components={components} />
                )}
                {description && (
                  <PortableText value={description} components={components} />
                )}
              </div>
              <div className={cn(
                "w-full border bg-white border-primary-100 rounded-2xl transition-all duration-300",
                showDetails
                  ? (showExpandedHistory ? "lg:max-w-[1052px] lg:h-auto min-h-[550px]" : "lg:max-w-[1052px] lg:h-[550px]")
                  : "max-w-[824px]"
              )}>
                {children}
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </TrackerContext.Provider>
  );
}
